// UT Matrix 정합화 Comparison Report List 모델

// Comparison Report List 조회 파라미터
export interface ComparisonReportSearchParam {
  rptNm?: string; // 보고서명
  utmIds?: string; // UT Matrix ID 목록 (콤마 구분 문자열, 멀티콤보박스 선택값)
  startDate?: string; // 작성일 시작일
  endDate?: string; // 작성일 종료일
  wrtUserId?: string; // 작성자 ID
  wrtUserNm?: string; // 작성자명 (검색용)
}

/**
 * 리포트 저장 결과
 * duplicated=true 이면 동일 조건(대상 UT Matrix + 구분)의 리포트가 이미 있어
 * 새로 만들지 않고 기존 RPT_ID를 돌려준 경우다.
 */
export interface SaveReportResult {
  rptId: string;
  duplicated: boolean;
  /** 중복인 경우 기존 리포트의 분석명 — 안내 문구에 사용 (BE가 내려주지 않으면 비어 있음) */
  rptNm?: string;
}

/** 항목구분코드 — TB_EELMB_UTM_RPT_OPIN_M.ATC_DIVS_CD (기계/전기) */
export type AtcDivsCd = 'MECH' | 'ELEC';

/** 분석의견유형 공통코드 그룹 — 상세코드의 OPT_VAL_CTN1이 ATC_DIVS_CD(MECH/ELEC)다 */
export const ANLS_OPIN_TP_CD_GROUP = 'ANLS_OPIN_TP_CD';

/**
 * 분석결과/의견 1행 — TB_EELMB_UTM_RPT_OPIN_M
 * PK: RPT_ID + UTM_ID + SORT_ORD + ATC_DIVS_CD + ANLS_OPIN_TP_CD
 *
 * UTM_ID는 기준(MST)이 아니라 **비교대상(TGT)**의 UTM_ID다.
 * (ref 패키지 AnalysisOpinionSection이 targets에서 role==='TGT'를 골라 쓴다)
 */
export interface RptOpinion {
  rptId?: string; // 보고서ID — BE 매퍼가 행 단위로 바인딩할 수 있도록 각 행에도 실어 보낸다
  utmId?: string; // 비교대상(TGT) UT Matrix ID
  sortOrd: number; // 정렬순서
  atcDivsCd: AtcDivsCd; // 항목구분코드 (기계/전기)
  anlsOpinTpCd: string; // 분석의견유형코드 (공통코드 ANLS_OPIN_TP_CD)
  anlsOpinTpNm?: string; // 표시용 항목명 (저장 대상 아님)
  anlsRltCtn: string; // 분석결과내용 — 보고서 반영전
  aiAnsCtn: string; // AI답변내용 — 보고서 반영후
  opinCtn: string; // 의견내용 — 사용자 입력
}

// Comparison Report List 그리드 데이터
export interface UtMatrixComparisonReportList {
  rptId?: string; // 보고서 ID
  rptNm?: string; // 보고서명
  lnUnitYn?: string; // 라인단위비교여부
  rmk?: string; // 비고
  utmNm?: string; // 대상 UT Matrix명(버전포함, 콤마구분)
  // 목록 그리드 3단 표시용 — "UTM_NM(VER_NO)" 형태. BE가 안 주면 utmNm에서 잘라 채운다
  mstDisp?: string; // 기준
  tgtDisp?: string; // 비교대상
  refDisp?: string; // 참조
  atchFileGrId?: string; // 첨부파일그룹ID
  useYn?: string; // 사용여부
  optValCtn1?: string; // 옵션값명1
  optValCtn2?: string; // 옵션값명2
  optValCtn3?: string; // 옵션값명3
  optValCtn4?: string; // 옵션값명4
  optValCtn5?: string; // 옵션값명5
  dataInsUserId?: string; // 데이터입력사용자ID
  dataInsUserNm?: string; // 데이터입력사용자명
  dataInsDtm?: string; // 데이터입력일시
  dataUpdUserId?: string; // 데이터수정사용자ID
  dataUpdUserNm?: string; // 데이터수정사용자명
  dataUpdDtm?: string; // 데이터수정일시
}
